import { render } from "./PosPurchase.vue?vue&type=template&id=8c6f1fd8&scoped=true&ts=true"
import script from "./PosPurchase.vue?vue&type=script&lang=ts"
export * from "./PosPurchase.vue?vue&type=script&lang=ts"

import "./PosPurchase.vue?vue&type=style&index=0&id=8c6f1fd8&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6f1fd8"]])

export default __exports__